import React, { Component } from "react";
import "./gainloss-transaction-screen-audit-modal.css";
import "./gainloss-transaction-screen-common-modal.css";
import "./gainloss-transaction-screen.scss";
import { inject, observer } from "mobx-react";
import { Form, Modal, Button } from "react-bootstrap";

const RenderRow = (props) => {
  const rows = props.fieldNames.map((col, index) => {
    const row = (
      <td key={index}>
        {col == "sourceSystemLoadDateTime" || col === "lastSavedDateTime"
          ? props.data[col] === null
            ? props.data[col]
            : new Date(props.data[col]).toLocaleString("en-US", {
                timeZone: "America/Denver",
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
                hour12: true,
                hour: "2-digit",
                minute: "2-digit",
              })
          : col === "productionDate"
          ? props.data[col].split("-")[1] + "-" + props.data[col].split("-")[0]
          : [
              "throughput",
              "gainLoss",
              "blendingShrinkage",
              "bsw",
              "lineTempChange",
              "cutOffVariance",
              "measurementDiscrepency",
            ].includes(col)
          ? props.data[col] >= 0
            ? (Math.round(props.data[col] * 100) / 100)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : "(" +
              Math.abs((Math.round(props.data[col] * 100) / 100).toFixed(2))
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
              ")"
          : props.data[col]}
      </td>
    );
    return row;
  });
  return rows;
};

@inject("CommonStore", "GainLossTransactionScreenStore")
@observer
class AuditModal extends Component {
  render() {
    return (
      <div style={{ zIndex: 1000 }}>
        <div className="modal-container" style={{ height: 300, width: 600 }}>
          <Modal
            className="transaction-audit-modal"
            show={this.props.GainLossTransactionScreenStore.showAuditPopUp}
            onHide={() => {}}
            size="xl"
            centered
          >
            <Form>
              <Modal.Title>Audit History</Modal.Title>
              <Modal.Body>
                <div style={{ margin: "10px", marginTop: "10px" }}>
                  {this.props.GainLossTransactionScreenStore.headerNames
                    .length > 0 && (
                    <div
                      style={{
                        width: "100%",
                        height: "275px",
                        overflow: "scroll",
                      }}
                    >
                      <table id="tableHeader">
                        <tbody>
                          <tr>{this.renderTableHeader()}</tr>
                          {this.renderTableData()}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.GainLossTransactionScreenStore.showAuditPopUp = false;
                  }}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        </div>
      </div>
    );
  }

  renderTableHeader() {
    return this.props.GainLossTransactionScreenStore.headerNames.map(
      (col, index) => {
        return (
          <th
            key={index}
            style={{ width: col === "Description" ? "230px" : "" }}
          >
            {col}
          </th>
        );
      }
    );
  }

  renderTableData = () => {
    return this.props.GainLossTransactionScreenStore.auditData.map(
      (auditRow, index) => {
        return (
          <tr key={index}>
            <RenderRow
              data={auditRow}
              fieldNames={this.props.GainLossTransactionScreenStore.fieldNames}
            />
          </tr>
        );
      }
    );
  };
}
export default AuditModal;
